import { IModalStyles, ILayerStyles } from '@fluentui/react';

/**
 * Globale Dialog-Styles für zentrierte Modals mit 90% Höhe
 * Verwendung: Alle Dialoge zum Bearbeiten von Details sollten diese Styles verwenden
 */

// Modal-Styles für zentrierte Dialoge mit 90% Höhe
export const centeredModalStyles: Partial<IModalStyles> = {
  main: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '900px',
    width: '90%',
    height: '90vh',
    maxHeight: '90vh',
    // Zentrierung
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '4px',
    boxShadow: '0 25.6px 57.6px 0 rgba(0,0,0,.22), 0 4.8px 14.4px 0 rgba(0,0,0,.18)',
  },
  scrollableContent: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
};

// Schmale Modal-Styles (z.B. für Formulare)
export const centeredModalStylesNarrow: Partial<IModalStyles> = {
  main: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '600px',
    width: '90%',
    height: '90vh',
    maxHeight: '90vh',
    // Zentrierung
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '4px',
    boxShadow: '0 25.6px 57.6px 0 rgba(0,0,0,.22), 0 4.8px 14.4px 0 rgba(0,0,0,.18)',
  },
  scrollableContent: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
};

// Breite Modal-Styles (z.B. für Listen)
export const centeredModalStylesWide: Partial<IModalStyles> = {
  main: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '1200px',
    width: '95%',
    height: '90vh',
    maxHeight: '90vh',
    // Zentrierung
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '4px',
    boxShadow: '0 25.6px 57.6px 0 rgba(0,0,0,.22), 0 4.8px 14.4px 0 rgba(0,0,0,.18)',
  },
  scrollableContent: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
};

// Layer-Styles für den Overlay-Hintergrund
export const modalLayerStyles: Partial<ILayerStyles> = {
  root: {
    zIndex: 1000,
  },
};

// Container-Styles für den Modal-Inhalt
export const modalContentStyles = {
  header: {
    padding: '16px 24px',
    borderBottom: '1px solid #edebe9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  body: {
    padding: '24px',
    flex: 1,
    overflow: 'auto',
  },
  footer: {
    padding: '16px 24px',
    borderTop: '1px solid #edebe9',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '8px',
  },
};
